import React, { Component } from 'react';
import MenuMain from "../../components/frontend/MenuMain";
import axios from "../../utils/axiosInstance";

class PrivacyPolicyFront extends Component {

  state = {
    title: "",
    description: "",
  };

  API_BASE = axios.defaults.baseURL; 
  PUBLIC_BASE = this.API_BASE.replace("/api", "");

  componentDidMount() {
    this.fetchFooterData();
  }

  fetchFooterData = async () => {
    try {
      const res = await axios.get("/get_additional_page?page_type=PrivacyPolicy", {});
      const d = res?.data?.data;
      if (d) {
        this.setState({
          title: d.title || "",
          description: d.description || "",
        });
      }
    } catch (error) {
      console.error("fetch error:", error);
    }
  };

  render() {
    const {
      title,
      description
    } = this.state;
    return (<>
      <MenuMain />
      <main className="main pages">
        {/* <div className="page-header breadcrumb-wrap">
          <div className="container">
            <div className="breadcrumb">
              <a href="index.php" rel="nofollow"><i className="fi-rs-home mr-5" />Home</a>
              <span /> Pages <span /> Terms & Conditions
            </div>
          </div>
        </div> */}
        <div className="page-content pt-50">
          <div className="container">
            <div className="row">
              <h1>{title}</h1>
              <p className="message-text" dangerouslySetInnerHTML={{ __html: description }} />
            </div>
          </div>
        </div>
      </main>
    </>);
  };
}

export default PrivacyPolicyFront;
